import ImageSection from "@/sections/home/ImageSection";
import PageHead from "@/components/PageHead";
import { useI18n } from "@/i18n/I18nProvider";
import { getStaticText } from "@/services/get-general-data";
import { getStaticTextByKey } from "@/utils/general-functions";
import { getHomePageData } from "@/services/get-homePage-data";
// import CustomHeading from "@/components/custom-heading";

export default function Products({
  productsCategory,
  productsList,
  staticText,
}) {
  const { t, locale } = useI18n();
  const staticTexts = getStaticTextByKey(staticText);
  return (
    <>
      <PageHead
        title={t.pages_main_tags.productsPage.title}
        description={t.pages_main_tags.productsPage.meta_desc}
      />

      <ImageSection
        productsCategory={productsCategory}
        productsList={productsList}
        title={staticTexts?.products_title.value.text[locale] || ""}
        titleVarient="h1"
      />
    </>
  );
}

export async function getServerSideProps({ res }) {
  try {
    res.setHeader(
      "Cache-Control",
      "no-store, no-cache, must-revalidate, proxy-revalidate",
    );

    const { productsCategory, productsList } = await getHomePageData();
    // const seoData = await getSeo("home");
    const staticText = await getStaticText("home");
    return {
      props: {
        productsCategory: productsCategory || [],
        productsList: productsList || [],
        // seoData: seoData,
        staticText: staticText,
      },
    };
  } catch (error) {
    return {
      props: {
        productsCategory: [],
        productsList: [],
        // seoData: [],
        staticText: [],
      },
    };
  }
}
